
// src/web/components/kpi-form-panel.jsx

import React from 'react'
import connect, { assignAll, assignTargetAll, isAssignAll } from '../../connects/kpi-form-panel'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  List,
  ListItem,
  ListCheckbox,
} from 'react-toolbox/lib/list'
import Checkbox from 'react-toolbox/lib/checkbox'
import {
  Button
} from 'react-toolbox/lib/button'
import theme from './themes/flat-card.css'
import {
  Input,
} from 'react-toolbox/lib/input'
import CompactInput from './compact-input.jsx'
import DatePicker from './date-picker.jsx'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import Dropdown from 'react-toolbox/lib/dropdown'
import {
  linkUI 
} from '../../helpers/form-validator'
import reportedDatePickerTheme from './themes/reported-date-picker.css'
import moment from 'moment'
import KPIPreview from './kpi-preview.jsx'
import KPIFormPanelTheme from './themes/kpi-form-panel.css'

const displayFormats = [
  { value: '', label: '123456' },
  { value: 'separate_1000', label: '123,456' },
  { value: 'decimal_1 separate_1000', label: '123,456.0' },
  { value: 'decimal_2 separate_1000', label: '123,456.00' },
  { value: 'separate_1000 signed', label: '+123,456/-123,456' },
  { value: 'decimal_1 separate_1000 signed', label: '+123,456.0/-123,456.0' },
  { value: 'decimal_2 separate_1000 signed', label: '+123,456.00/-123,456.00' },
]

function accumulationMethods(t) {
  return [
    { value: true, label: t('label:実績値を期間内で累計する'), legend: t('label:実績値を期間内で累計の説明') },
    { value: false, label: t('label:実績値を日毎に集計する'), legend: t('label:実績値を日毎に集計の説明') },
  ]
}

function prependUnits(t) {
  return [
    { value: true, label: t('label:値の前に表示') },
    { value: false, label: t('label:値の後に表示') },
  ]
}
const styles ={
  containerPreview: {
    alignItems: 'center', 
    display: 'flex', 
    flexDirection: 'column',
    marginBottom: 16
  }
}
class KPIFormPanel extends React.Component {
  render() {
    const {
      t,
      ui,
      kpi,
      isUpdating,
      updateUI,
      validateAndSubmit,
    } = this.props

    var step = 1
    if (ui.displayFormat.indexOf('decimal_1') >= 0)
      step = 0.1
    else if (ui.displayFormat.indexOf('decimal_2') >= 0)
      step = 0.01
    else if (ui.displayFormat.indexOf('decimal_3') >= 0)
      step = 0.001

    const format = _.find(displayFormats, (item) => item.value == ui.displayFormat)
    const formatLabel = format && format.label || '123456'

    return (
      <Card theme={theme}>
        <form onSubmit={(e) => validateAndSubmit(this.props, e)}>
          <CardText>
            <normal><strong>{t('label:KPI名')}</strong></normal>
            <Input name="name" required
              label={t('label:KPI名の説明')}
              value={ui.name}
              error={ui.nameError && t('error:KPI名を入力してください')}
              onChange={linkUI(this, 'name')} />

            <normal><strong>{t('label:開始日')}&nbsp;/&nbsp;{t('label:終了日')}</strong></normal>
            <div style={{ display: 'flex', marginBottom: '20px' }}>
              <div style={{ flexGrow: 1 }}>
                <DatePicker label={t('label:開始日')}
                    value={ui.startDate.toDate()}
                    onChange={(date)=> updateUI({ startDate: moment(date) })}
                    color={ui.startDateError ? 'red' : undefined} />
              </div>
              <div>&nbsp;&nbsp;</div>
              <div style={{ flexGrow: 1 }}>
                <DatePicker label={t('label:終了日')}
                    value={ui.endDate.toDate()}
                    minDate={ui.todayDate.toDate()}
                    onChange={(date)=> updateUI({ endDate: moment(date) })}
                    color={ui.endDateError ? 'red' : undefined} />
              </div>
            </div>

            <Checkbox key="checkbox" label={t('label:翌期分自動作成')}
                checked={ui.generateNextAtDaysTarget} 
                onChange={(value)=> updateUI({ generateNextAtDaysTarget: !ui.generateNextAtDaysTarget })} />
            {ui.generateNextAtDaysTarget &&
            <div style={{ display: 'flex', marginBottom: '20px' }}>
              <div style={{ flexGrow: 1 }}>
                <DatePicker
                    value={ui.generateNextAtDays.toDate()}
                    onChange={(date)=> updateUI({ generateNextAtDays: moment(date) })}
                    color={ui.generateNextAtDaysError ? 'red' : undefined} />
              </div>
            </div>
            }

            <normal><strong>{t('label:単位')}</strong></normal>
            <Input name="unit" required
                  label={t('label:単位の説明')}
                  value={ui.unit}
                  error={ui.unitError && t('error:単位を入力してください')}
                  onChange={linkUI(this, 'unit')} />

            <normal><strong>{t('label:単位の表示位置')}</strong></normal>
            <Dropdown source={prependUnits(t)}
                  value={ui.prependUnit}
                  onChange={(value)=> updateUI({ prependUnit: value })} />

            <normal><strong>{t('label:表示形式')}</strong></normal>
            <Dropdown source={displayFormats}
                  value={ui.displayFormat}
                  onChange={(value)=> updateUI({ displayFormat: value })} />

            <normal><strong>{t('label:実績値の集計方法')}</strong></normal>
            <Dropdown source={accumulationMethods(t)}
                  disabled={kpi}
                  template={(item)=> <div style={{ display: 'flex', flexDirection: 'column' }}><div><strong>{item.label}</strong></div><div style={{ fontSize: '80%' }}>{item.legend}</div></div>}
                  value={ui.accumulatedTotal}
                  onChange={(value)=> updateUI({ accumulatedTotal: value })} />
          </CardText>
          <CardText style={styles.containerPreview}>
            <normal><strong>{t('label:プレビュー')}</strong></normal>
            <KPIPreview ui={ui} t={t} formatLabel={formatLabel} label={ui.displayFormat}/>
          </CardText>
          <CardText>
            <normal><strong>{t('label:担当者と目標値の割り当て')}</strong></normal>
            <List>
              <ListItem selectable={false} ripple={false}
                  leftActions={[
                    <Checkbox key="checkbox" checked={isAssignAll(ui.assignments)}
                        onChange={(value)=> updateUI({ assignAll: !isAssignAll(ui.assignments), assignments: assignAll(ui.assignments, value) })} />,
                    <div key="label" style={{ marginTop: '-16px' }}>{t('label:すべて選択')}</div>
                  ]}
                  rightActions={[
                    <Checkbox key="checkbox" checked={ui.assignSameTarget}
                        onChange={(value)=> updateUI({ assignSameTarget: !ui.assignSameTarget, assignmentAllValue: undefined })} />,
                    <div key="text" style={{ marginTop: '-16px' }}>{t('label:同じ値を設定')}</div>
                  ]} />
            {ui.assignSameTarget && <ListItem selectable={false} ripple={false}
              rightActions={[
                  <CompactInput name={`target.all`}
                      type="number"
                      step={step}
                      hint={t('label:目標値を入力')}
                      error={ui.assignmentAllError && t('error:目標値を入力してください')}
                      value={ui.assignmentAllValue}
                      onChange={(value)=> updateUI({
                        assignments: assignTargetAll(ui.assignments, value),
                        assignmentAllValue: value
                      })}
                    />]}>
            </ListItem>}
            {ui.assignments && _.map(ui.assignments, (assign, i)=> {
              return (
                <ListItem key={assign.id} selectable={false} ripple={false} theme={KPIFormPanelTheme} className={!assign.assign && 'checked' || ''}
                    leftActions={[
                      <Checkbox checked={assign.assign}
                          onChange={(value)=> updateUI({
                            assignments: Object.assign(
                              {}, ui.assignments,
                              { [i]: Object.assign({}, assign, { assign: value })}
                            )})
                          }
                          name={`assign.${assign.id}`}
                          key="checkbox" />
                    ]}
                    itemContent={
                      <div style={{ display: 'flex', width: '100%' }}>
                        <div>{assign.name}</div>
                        <div style={{ marginLeft: 'auto' }}>
                        <CompactInput name={`target.${assign.id}`}
                                required={assign.assign}
                                type="number"
                                step={step}
                                disabled={!assign.assign}
                                hint={t('label:目標値を入力')}
                                error={assign.targetError && t('error:目標値を入力してください')}
                                value={assign.target}
                                onChange={(value)=> updateUI({
                                  assignments: Object.assign(
                                                  {}, ui.assignments,
                                                  { [i]: Object.assign({}, assign, { target: value })})
                                })
                                } />
                        </div>
                      </div>} />)
            })}
            </List>
          </CardText>

          <CardActions>
            <Button raised primary
              disabled={isUpdating}
              type="submit"
              style={{ width: '100%' }}
              label={kpi ? t('label:更新') : t('label:登録')} />
          </CardActions>
        </form>
      </Card>
    )
  }
}

export const RawKPIFormPanel = KPIFormPanel
export default connect(KPIFormPanel)



// WEBPACK FOOTER //
// ./src/web/components/kpi-form-panel.jsx